var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxseditalt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxs-edit-alt.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.3727 2.85156L18.1436 5.62248L16.0313 7.73576L13.2604 4.96485L15.3727 2.85156ZM4.28906 13.9241V16.6951H7.05998L14.7253 9.04086L11.9543 6.26995L4.28906 13.9241Z",
    fill: "#102565"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxseditalt);
export default __webpack_public_path__ + "static/media/bxseditalt.98e9b6ee56a27032a57c35469008dfb1.svg";
export { ForwardRef as ReactComponent };